import axios from 'axios';

const bgUrl = process.env.VUE_APP_BASE_URL;

export const request = axios.create({
    baseURL: bgUrl,
    timeout: 5000,
    headers:{
        'Content-Type': 'application/json'
    }
});

request.interceptors.request.use(
    config => {
        // 请求前处理
        return config;
    },
    error => {
        // 异常处理
        Promise.reject(error);
    }
);

request.interceptors.response.use(
    response => {
        // 结果处理
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.statusText);
        }
    },
    error => {
        // 异常处理
        if (error.response.status === 401) {

        } else if (error.response.status === 405) {

        }
        return Promise.reject(error.response);
    }
);

